import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";
import {HEADER_BAR_HEIGHT} from "../../../../constants/fixedStyleVariables";

export const TopMenuContainer = styled.div`
  z-index: 99999;
  width: 100%;
  height: ${HEADER_BAR_HEIGHT}px;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${Variables.colors.complementary};
  border-bottom: ${props => props.borderBottom ? `1px solid ${Variables.colors.complementary_400}` : `0`};
  ${props => {
    if ( props.shadow ) {
      return `
        -webkit-box-shadow: 0 0 12px 0 #ccc;
        -moz-box-shadow: 0 0 12px 0 #ccc;
        box-shadow: 0 0 12px 0 #ccc;
      `;
    }
  }}
  .inner-container {
    max-width: ${props => props.fluid ? `100%` : `1600px`};
    padding: 0 12px 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    -webkit-align-items: center;
    -ms-flex-align: center;
    height: inherit;
    margin: 0 auto;
    .left-side, .right-side {
      .left-side-ul, .right-side-ul {
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        align-items: center;
        & > li {
          margin-left: 8px;
          //&:last-child {
          //  margin-left: 0;
          //}
        }
      }
    }
    .left-side {
      display: flex;
      position: absolute;
      left: 20px;
      top: calc(50% - 20px);
      justify-content: space-between;
      align-items: center;
      .separator {
        width: 1px;
        height: 32px;
        background-color: ${Variables.colors.complementary_400};
      }
      i.left-side-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 0 8px;
        cursor: pointer;
        &:before {
          color: ${Variables.colors.complementary_700};
          margin-left: 0;
          font-size: 24px;
        }
        &.pressed, &:hover {
          background-color: ${Variables.colors.complementary_300};
        }
      }
      .profile {
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-right: 9px;
        min-width: 72px;
        .profile-project-name {
          font-size: ${Variables.font_sizes.x_medium};
          color: ${Variables.colors.primary_vivid};
          margin-bottom: 3px;
          max-width: 150px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .profile-user-name {
          font-size: ${Variables.font_sizes.x_small};
          color: ${Variables.colors.complementary_800};
          max-width: 150px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        i.profile-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin: 0 4px 0 0 !important;
          &:before {
            margin-left: 0;
            font-size: 8px;
            color: ${Variables.colors.complementary_800};
          }
          &.pressed:not(.disable), &:not(.disable):hover {
            background-color: ${Variables.colors.complementary_300};
          }
          &.disable:before {
            color: ${Variables.colors.complementary_500};          
          }
        }
      }
      .notifications{
        position: relative;
        i.left-side-icon{
          &.pressed, &:hover{
            background-color: ${Variables.colors.complementary_300};
          }
        }
      }
      .sidebar-badge {
        background-color: ${Variables.colors.red_600};
        position: absolute;
        width: 16px;
        height: 16px;
        border-radius: 32px;
        top: 4px;
        right: 6px;
        span {
        display: flex;
          justify-content: center;
          align-items: center;
          font-size: ${Variables.font_sizes.x_small};
          width: 100%;
          height: 100%;
          font-family: Number, sans-serif;
          color: ${Variables.colors.complementary};
          text-align: center;
        }
      }
      .left-side-ul {
        justify-content: flex-end;
      }
    }
    .right-side {
      .right-side-ul {
        justify-content: flex-start;
      }
    }
  }
  
`;

export const Separator = styled.div`
  width: 1px;
  height: 26px;
  background-color: ${Variables.colors.complementary_400};
`;